// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadApplications = function () {
//     loadAllApplication();
// };

// $(document).ready(function () {

//     // ADD Application
//     $("#applyForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("userFullName", $("#userFullName").val());
//         formData.append("userPhoneNo", $("#userPhoneNo").val());
//         formData.append("userEmail", $("#userEmail").val());
//         formData.append("applyPosition", $("#applyPosition").val());
//         formData.append("userResume", $("#userResume")[0].files[0]);
//         $.ajax({
//             url: `${API_BASE_URL}/api/apply/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Application Submit Successfully!");
//                 $("#applyForm")[0].reset();

//                 const modal = window.bootstrap.Modal.getInstance(document.getElementById("applyModal"));
//                 modal.hide();
//                 loadAllApplication();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to send Application!");
//             }
//         });
//     });
//     // LOAD ALL Apply DATA
//     function loadAllApplication() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/apply/all`,
//             type: "GET",
//             success: function (applications) {
//                 let rows = "";
//                 applications.reverse().forEach((a, i) => {
//                     rows += `
//                         <tr>
//                             <td>${i + 1}</td>
//                             <td>${a.userFullName}</td>
//                             <td>${a.userPhoneNo}</td>
//                             <td>${a.userEmail}</td>
//                             <td>${a.applyPosition}</td>
//                             <td>
//                                 <button  class="btn btn-primary btn-sm viewResume" data-file="${a.userResume}">
//                                     View
//                                 </button>
//                             </td>
//                             <td>
//                                 <button class="btn btn-danger btn-sm deleteApplication" data-id="${a.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });
//                 $("#allApplicationData").html(rows);
//             },
//             error: function (err) {
//                 console.error(err);
//             }
//         });
//     }
//     // VIEW RESUME
//     $(document).on("click", ".viewResume", function () {
//         const fileName = $(this).data("file");

//         if (!fileName) {
//             alert("Resume not uploaded!");
//             return;
//         }

//         const fileUrl = `${API_BASE_URL}/assets/Images/${fileName}`;
//         window.open(fileUrl, "_blank");
//     });
//     // DELETE Apply
//     $(document).on("click", ".deleteApplication", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure want to delete this Application?")) return;

//         $.ajax({
//             url: `${API_BASE_URL}/api/apply/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Application Deleted Successfully!");
//                 loadAllApplication();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to delete Application!");
//             }
//         });
//     });
// });

import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE FUNCTION OUTSIDE
function loadAllApplication() {
    $.ajax({
        url: `${API_BASE_URL}/api/apply/all`,
        type: "GET",
        success: function (applications) {
            let rows = "";
            applications.reverse().forEach((a, i) => {
                rows += `
                    <tr>
                        <td>${i + 1}</td>
                        <td>${a.userFullName}</td>
                        <td>${a.userPhoneNo}</td>
                        <td>${a.userEmail}</td>
                        <td>${a.applyPosition}</td>
                        <td>
                            <button class="btn btn-primary btn-sm viewResume" data-file="${a.userResume}">
                                View
                            </button>
                        </td>
                        <td>
                            <button class="btn btn-danger btn-sm deleteApplication" data-id="${a.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });
            $("#allApplicationData").html(rows);
        },
        error: function (err) {
            console.error(err);
        }
    });
}

// ✅ EXPOSE TO REACT
window.loadApplications = function () {
    loadAllApplication();
};

$(document).ready(function () {

    // ADD Application
    $("#applyForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("userFullName", $("#userFullName").val());
        formData.append("userPhoneNo", $("#userPhoneNo").val());
        formData.append("userEmail", $("#userEmail").val());
        formData.append("applyPosition", $("#applyPosition").val());
        formData.append("userResume", $("#userResume")[0].files[0]);

        $.ajax({
            url: `${API_BASE_URL}/api/apply/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function () {
                showSuccessModal("Application Submit Successfully!");
                $("#applyForm")[0].reset();

                const modal = window.bootstrap.Modal.getInstance(document.getElementById("applyModal"));
                modal.hide();
                loadAllApplication();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to send Application!");
            }
        });
    });

    // VIEW RESUME
    $(document).on("click", ".viewResume", function () {
        const fileName = $(this).data("file");

        if (!fileName) {
            alert("Resume not uploaded!");
            return;
        }

        const fileUrl = `${API_BASE_URL}/assets/Images/${fileName}`;
        window.open(fileUrl, "_blank");
    });

    // DELETE Apply
    $(document).on("click", ".deleteApplication", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure want to delete this Application?")) return;

        $.ajax({
            url: `${API_BASE_URL}/api/apply/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Application Deleted Successfully!");
                loadAllApplication();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to delete Application!");
            }
        });
    });
});